import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ForgottenPassword } from "./forgottenpassword";
import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { LoaderService } from "../../LoaderService";

@Component({
  selector: 'mft-forgotten',
  templateUrl: './forgottenpassword.component.html'
})
export class ForgottenPasswordComponent implements OnInit {
  forgottenForm: FormGroup;
  forgotten: ForgottenPassword = new ForgottenPassword();  

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    public globalService: GlobalService,
    public loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.forgottenForm = this.fb.group({
      username: ['', [Validators.required]]
    });
  }

  forgottenPasswordSubmit(): void {
    if (this.forgottenForm.dirty && this.forgottenForm.valid) {
      // Copy the form values over the product object values
      let p = Object.assign({}, this.forgotten, this.forgottenForm.value);      
      this.loaderService.display(true);
      this.authService.obtainAccessToken(p)
        .subscribe(
        () => {
          this.onForgottenComplete();          
          this.loaderService.display(false);
          this.redirectToRelevantAccessArea();
        },
        (error: any) => {          
          this.loaderService.display(false);
          this.globalService.showError("Login", <any>error)
        }
        );
    } else if (!this.forgottenForm.dirty) {
      this.onForgottenComplete();
    }
  }

  redirectToRelevantAccessArea(): void {
    this.router.navigate([this.appCommonService.reDirectURL]);
  }

  onForgottenComplete(): void {
    // Reset the form to clear the flags
    this.forgottenForm.reset();    
  }

  ngAfterViewInit() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/forgottenpassword/forgottenpassword.component.ts